import { useQuery } from "@tanstack/react-query";

import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const useUser = () => {
  const axiosPrivate = useAxiosPrivate();

  const getLoggedUser = async () => {
    const loggedUser = await axiosPrivate({
      method: "GET",
      url: "/User",
    }).then((res) => res.data);

    return loggedUser;
  };

  return useQuery(["getLoggedUser"], getLoggedUser, {
    enabled: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: 3,
    staleTime: 1000 * 60 * 10,
  });
};

export default useUser;
